import React from "react";
import { Link } from "react-router-dom";

const PROJECTS = [
  { slug: "crm", to: "/project/crm", label: "CRM" },
  { slug: "familytree", to: "/project/family-tree", label: "FamilyTree" },
  { slug: "exchange", to: "/project/coin-exchange", label: "CoinExchange" },
  { slug: "vcx", to: "/project/vcx", label: "VCX" },
  { slug: "nft", to: "/project/nft", label: "NFT" },
  { slug: "terapool", to: "/project/terapool", label: "Terapool" },
];

export default function OtherProjects({ active }) {
  return (
    <div>
      <div className="flex flex-wrap xs:justify-center space-ml-8 xs:c-g-12 xs:r-g-12">
        {PROJECTS.map((p) => (
          <Link
            key={p.slug}
            to={p.to}
            className={
              "op-pill radius-100 xs:f-12 f-14 xs:px-16 px-24 xs:py-12 py-16" +
              (active === p.slug
                ? " active"
                : " bg-secondary text-secondary")
            }
          >
            {p.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
